<template>
    <v-container fluid>
        <!-- FLOATING SAVE BUTTON -->
        <v-btn v-if="!nonConformiteEstTerminee" :disabled="!formValid || nonConformiteEstTerminee || (imageStructure.length === 0 && !canSkipImage)" @click="submit('onFloatingSave')"
               class="success" id="btn_save" :loading="loading" fab dark fixed right bottom>
            <v-icon>save</v-icon>
        </v-btn>

        <!-- TOP INFOS AND FAVORITE BUTTON -->
        <v-layout class="my-2" row wrap>
            <!-- infos -->
            <v-layout row wrap>
                <v-flex>
                    <label class="font-weight-bold">Date de création : </label>
                    <span v-if="!!nonConformite.createdAt"><label>{{ formatDateTime(nonConformite.createdAt) }}</label></span>
                    <br/>

                    <label class="font-weight-bold">Demandeur : </label>
                    <span><label>{{ !!nonConformite.user ? nonConformite.user.fullName : loggedUser.fullName }}</label></span>
                    <br/>


                    <span v-if="!!nonConformite.numeroNc && nonConformite.type !== 'qualite'">
                        <label class="font-weight-bold">Numéro de Non-Conformité : </label>
                        <span id="nc-numero-label"><label>{{ nonConformite.numeroNc }}</label></span>
                        <br/>
                    </span>

                    <label class="font-weight-bold" v-if="!!nonConformite.projet">Numéro du project : </label>
                    <span v-if="!!nonConformite.projet" id="projet-label"><label>{{ nonConformite.projet || 'N/D' }}</label></span><br/><br/>
                </v-flex>
            </v-layout>

            <!--  favorite button (nc  membership) -->
            <v-layout
                row
                wrap
                align-end
                justify-end
                fill-height
                class="text-xs-right"
            >
                <v-flex md12>
                    <div class="text-xs-right d-inline-flex">
                        <v-btn
                            v-if="!isCreating"
                            :color="abonnementBackgroundIconeColor"
                            icon
                            @click="setAbonnementNonconformite(loginStore.loggedUser.id)"
                            :disabled="nonConformiteEstTerminee"
                        >
                            <v-icon :color="abonnementIconeColor">star</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="canDeleteNc"
                            id="btn-supprimer-nc"
                            color="error"
                            icon
                            title="Supprimer la GNC"
                            @click="ouvrirSuppression"
                        >
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-layout>

        <!-- GALLUP ASSIGNATION INFOS (if NC has a question_answer_id)-->
        <div class="shadow my-3">
            <GallupInfos
                v-if="!!nonConformite.questionAnswerId"
                :gallupInfos="gallupInfos"
            />
        </div>

        <!-- FORM VALIDATION -->
        <v-form ref="form" v-model="formValid" lazy-validation>
            <!-- LAYOUT SECTION (SHOWS LAYOUT FOR EACH NC TYPES) -->
            <component
                ref="childMainComponent"
                :is="currentCreateLayout"
                :nonConformite="nonConformite"
                :isDisabled="nonConformiteEstTerminee"
                :readOnly="nonConformiteEstTerminee"
                :isGNCQualite="isGNCQualite"
                :isGNCSupervisor="isGNCSuperviseur"
                :isGNCAdmin="isGNCAdmin"
                :isLoadingTransition="loadingTransition || loading"
                :correctivesActions="getCorrectivesActions"
                :employeeListSIGM="entrepriseStore.employes"
                :imagesStructure="imageStructure"
                :imagesSolution="imagesSolution"
                :canSkipImage="canSkipImage"
                :projectIncludesUnit="projectIncludesUnit"
                :projectMessages="projectMessages"
                :projectErrorMessages="projectErrorMessages"
                :stageUnits="stageUnitsAutocompleteItems"
                :partNos="entrepriseStore.partNos"
                :partNosAdd="entrepriseStore.partNosAdd"
                :projectPartNos="projectAvailableParts"
                :stageModels="entrepriseStore.stages"
                :categories="nonConformiteStore.categories"
                :departments="getAllDepartments"
                :causes="nonConformiteStore.causes"
                :employees="entrepriseStore.employes"
                :locations="entrepriseStore.locations"
                :providers="entrepriseStore.fournisseurs"
                :newSytelineProjectNumber="newSytelineProjectNumber"
                :tryToCreateProjectFail="tryToCreateProjectFail"
                :isSpinnerLoading="entrepriseStore.showSpinnerLoading"
                @setProjectInfo="setProjectInfo"
                @searchNoAssemblage="searchNoAssemblage($event)"
                @changeNoAssemblage="changeNoAssemblage($event)"
                @addNewProject="addNewProjectToSyteline('GNC')"
                @applyTransition="appliquerTransition"
                @uploadImage="uploadImage"
                @uploadImageSolution="uploadImageSolution"
                @popUpImage="popUpImage"
                @removeImage="removePhoto"
                @uploadFile="uploadFichiers"
                @uploadFileSolution="uploadFichiersSolution"
                @removeFile="removeFile"
                @abonnementActionCorrective="setCorrectiveActionMembers"
                @checkUp="checkUp"
                @resolutionMembersList="setResolutionMembersList($event)"
                @updateGncMessage="updateGncMessage($event)"
                @changeAxeAffaire="changeAxeAffaire($event)"
            />

            <!-- NOTES SECTION (ticket #39: shown on creation too, the typed note is saved with the NC) -->
            <Notes
                :readOnly="nonConformiteEstTerminee"
                :isDisabled="nonConformiteEstTerminee || !nonConformite.id"
                :notes="nonConformite.notes"
                @addNewNote="ajouterNote"
                @noteTextChange="noteTextChange"
                :note="newNote"
            />

            <!-- MEMBERS SECTION
            <div class="shadow pa-2 my-3">
                <h2>Ajout d'utilisateur en suivi </h2>
                <NCAbonnements
                    :non-conformite="nonConformite"
                    :items="nonConformite.abonnes"
                    :readonly="nonConformiteEstTerminee"
                    :users="entrepriseStore.users"
                    @change="nonConformite.abonnes = $event"
                />
            </div>-->
        </v-form>

        <!-- HISTORY SECTION -->
        <div class="shadow my-3">
            <Histo
                :non-conformite="nonConformite"
            />
        </div>

        <!-- ChoiceBoxMessage -->
        <div>
            <!--<v-btn @click="openChoiceBoxMessage(choiceBoxMessageContent, choiceBoxMessageBtnLabels)">Open ChoiceBoxMessage</v-btn>-->
            <choice-box-message
                ref="choiceBoxMessage"
                @alert-response="handleChoiceBoxMessageResponse"
            />
        </div>

        <!-- DIALOGS -->
        <!-- images dialog -->
        <DialogPhotos
            :image="image"
            @remove="removePhoto($event)"
            :can-delete="(isOwner || isGNCAdmin) && image.origin !== 'client'"
        />

        <!-- ticket #41: delete a quality NC created by mistake -->
        <DialogSuppressionNc
            :show="suppression.show"
            :apercu="suppression.apercu"
            :loadingApercu="suppression.loadingApercu"
            :loading="suppression.loading"
            @cancel="suppression.show = false"
            @confirm="supprimerNc"
        />
    </v-container>
</template>

<script>
    import { LOGIN_STORE, NON_CONFORMITES_STORE, ENTREPRISE_STORE, APPLICATION_STORE } from "../../constants";
    import { mapState, mapGetters, mapActions } from 'vuex';
    import isEqual from 'lodash/isEqual';
    import utils from '../../utils';

    //controls
    import GallupInfos from '../../components/controls/GallupInfos';
    import ImagesUpload from "../../components/controls/ImagesUpload";
    import FilesUpload from "../../components/controls/FilesUpload";
    import Notes from '../../components/controls/Notes';
    import Histo from "../../components/controls/Histo";
    import DialogPhotos from "../../components/controls/DialogPhotos";
    import DialogSuppressionNc from "../../components/controls/DialogSuppressionNc";

    //create layouts (Qualite, Maintenance, SAV)
    import CreateQualite from '../../components/create/CreateQualite';
    import CreateMaintenance from '../../components/create/CreateMaintenance';
    import CreateSav from '../../components/create/CreateSav';
    import NCAbonnements from "../../components/controls/NC-Abonnements";

    //ChoiceBoxMessage
    import ChoiceBoxMessage from '@/components/controls/ChoiceBoxMessage.vue';

    export default {
        name: "create",
        components: {
            NCAbonnements,
            //controls
            DialogPhotos,
            DialogSuppressionNc,
            Histo,
            GallupInfos,
            ImagesUpload,
            FilesUpload,
            Notes,
            ChoiceBoxMessage,

            //create layouts
            CreateQualite,
            CreateMaintenance,
            CreateSav
        },
        //actions à la construction
        created() {
            try {
                Promise.all([
                    this.fetchUsers(),
                    this.fetchParamsNonConformite(),
                    this.fetchDepartments(),
                    this.fetchStageUnits(),
                    this.fetchStages(),

                    //Anciennement SIGM
                    //this.fetchEmployees(),
                    //this.fetchSuppliers(),
                    //this.fetchPartNos(),

                    //Changer vers Syteline
                    this.fetchEmployeesFromSyteline(),
                    this.fetchSuppliersFromSyteline(),
                    this.fetchAllLocationFromSyteline(),
                ]).then(response => {
                    if (this.$router.currentRoute.name === 'edit') {
                        this.setParamsEditNC();
                    } else {
                        this.setParamsCreateNC();
                    }
                });
            } catch (e) {
                this.alert('error', e.message());
            }
        },
        //données
        computed: {
            //VUEX
            ...mapState({
                nonConformiteStore: state => state.nonConformiteStore,
                loginStore: state => state.loginStore,
                entrepriseStore: state => state.entrepriseStore,
            }),
            ...mapGetters([
                //entreprise store
                'getUsers',

                //departments store
                'getAllDepartments',

                //correctives actions store
                'getCorrectivesActions',
            ]),

            //COMPUTED PROPERTY
            //shows current page layout based on NC type
            currentCreateLayout() {
                return this.nonConformite.type === 'qualite' ? 'CreateQualite' :  this.nonConformite.type === 'maintenance' ? 'CreateMaintenance' : 'CreateSav';
            },

            nonConformiteEstTerminee(){
                return (this.nonConformite.etat === 'demande_rejetee' || this.nonConformite.etat === 'travail_approuve') && !this.isGNCAdmin;
            },
            loggedUser() {
                return this.$store.getters[LOGIN_STORE.getters.LOGGED_USER];
            },

            isOwner() {
                return this.$store.getters[LOGIN_STORE.getters.LOGGED_USER].id === this.nonConformite.userId;
            },

            isGNCAdmin() {
                return this.$store.getters[LOGIN_STORE.getters.IS_GNC_ADMIN];
            },

            isGNCQualite() {
                return this.$store.getters[LOGIN_STORE.getters.IS_GNC_QUALITE];
            },

            //a note is either already saved on the NC or currently typed (submit() saves it first)
            hasNote() {
                const savedNotes = Array.isArray(this.nonConformite.notes) && this.nonConformite.notes.length > 0;
                const pendingNote = !!this.newNote && this.newNote.trim() !== '';
                return savedNotes || pendingNote;
            },

            //ticket #39: gnc_qualite users may save / complete work without image if the NC has a note
            canSkipImage() {
                return this.isGNCQualite && this.hasNote;
            },

            //ticket #41: gnc_qualite may delete a quality NC created by mistake, unless it is closed
            canDeleteNc() {
                return !this.isCreating && this.isGNCQualite && this.isNcQualite && this.nonConformite.etat !== 'fermer';
            },

            isGNCSuperviseur() {
                return this.$store.getters[LOGIN_STORE.getters.IS_GNC_SUPERVISOR];
            },

            isGNCUser() {
                return this.$store.getters[LOGIN_STORE.getters.IS_GNC_USER];
            },
            //tells if page is currently in create mode or not
            isCreating(){
                return this.$router.currentRoute.name === 'create';
            },

            //abonnements
            estAbonne(){
                let estAbonne = false;
                let tabAbonnements = this.nonConformite.abonnes.concat(this.nonConformite.abonnesActionCorrective);

                if(tabAbonnements.length > 0 && this.loginStore.loggedUser != null){
                    let res = tabAbonnements.find( u => u != null && u.id === this.loginStore.loggedUser.id);

                    if(res != null){
                        estAbonne = true;
                    }
                }

                return estAbonne;
            },

            abonnementIconeColor(){
                return this.estAbonne ? 'white' : 'black';
            },

            abonnementBackgroundIconeColor(){
                return this.estAbonne ? 'yellow darken-2' : 'blue-grey lighten-5';
            },
            isNcQualite() {
                return this.nonConformite.type === 'qualite';
            },
            isNcMaintenance() {
                return this.nonConformite.type === 'maintenance';
            },
            isNcSAV() {
                return this.nonConformite.type === 'sav';
            },

            stageUnitsAutocompleteItems() {
                if (this.projectAvailableUnits.length > 0) {
                    return this.projectAvailableUnits;
                }
                return this.entrepriseStore.units;
            },
        },
        data() {
            return {
                NON_CONFORMITES_STORE: NON_CONFORMITES_STORE,

                //ticket #41: deletion dialog state
                suppression: { show: false, apercu: null, loadingApercu: false, loading: false },
                nonConformiteSupprimee: false,

                //add member autocomplete v-model
                abonnementNouvelUtilisateur: null,
                cycle: false,

                //form v-model
                formValid: true,
                id: null,

                //image for images dialog
                image: {
                    visible: false,
                    src: '',
                },

                //nc images
                imageStructure: [],
                //nc solution images
                imagesSolution: [],

                loading: false,
                loadingTransition: false,
                message: {
                    type: "",
                    text: ""
                },

                //Gallup assignation infos
                gallupInfos: {},

                //NC
                nonConformite: {
                    id: null,
                    titre: '',
                    description: '',
                    tags: [],
                    projet: '',
                    noAssemblage: '',
                    ncParentDepartementId: null,
                    ncDepartementId: null,
                    stageModel: '',
                    stageId: null,
                    stageUnit: '',
                    stageUnitId: null,
                    ncCategorieId: null,
                    ncCauseId: null,
                    causeFournisseurId: null,
                    causeEmployeId: null,
                    solutionRequise: false,
                    solutionProposee: '',
                    solutionAlternative: '',
                    raisonRefus: '',
                    history: [],
                    dateEcheance: new Date().toISOString().substr(0, 10),
                    estimeTemps: '',
                    estimeHeures: null,
                    estimeMinutes: null,
                    gravite: 1,
                    frequence: 1,
                    assignationEmployeSigm: null,
                    actionCorrectiveRequise: false,
                    actionCorrectiveProposee: '',
                    actionCorrectiveComplete: false,
                    numeroNc: null,
                    abonnes: [],
                    abonnesActionCorrective: [],
                    type: '',
                    estime: [],
                    //files
                    ncFichiers: [],
                    //solution files
                    ncFichiersSolution: [],
                    isReception: false,
                    locationNc: 'rive_nord',
                    axesAffaires:null,
                    hoursTasks:null,
                },

                panel: [true, true, true],
                currentPartSelected:'',

                //project number
                projectIncludesUnit: false,
                projectErrorMessages: [],
                projectMessages:[],

                projectAvailableParts: [],
                projectAvailableUnits: [],
                //page title
                title: "",

                //new note
                newNote: "",

                //Syteline Data
                lastGNCProjectsNumber:null,
                newSytelineProjectNumber:null,
                tryToCreateProjectFail:null,

                //ChoiceBoxMessage
                resolveChoiceBox: null,
                isChoiceMade:false,
                choiceBoxMessageTitle:'Attention!',
                choiceBoxMessageContent:{
                    title:'Attention!',
                    message:'Vous n\'avez pas coché la case pour la création d\'un OF.\n' +
                        'Êtes-vous certain de vouloir créer une GNC sans OF ???\n'
                },
                choiceBoxMessageBtnLabels: [
                    { name:'avec', label:'NON, CRÉER UN OF POUR PUNCHER DU TEMPS' },
                    { name:'sans', label:'Oui' },
                    { name:'annuler', label:'Annuler' },
                ],

                //Axes Affaires
                axeAffaire:null,
            }
        },
        methods: {
            //VUEX
            ...mapActions([
                //correctives actions store
                'fetchCorrectivesActionsByType',

                //non conformite store
                'supprimerFichierNonConformite',
                'ajouterNoteNonConformites',
                //'fetchPartSuppliers',
                'fetchParamsNonConformite',
                'fetchNonConformiteById',

                //departments store
                'fetchDepartments',

                //entreprise store
                'fetchStageUnits',
                'fetchStages',
                'fetchEmployees',
                'fetchEmployeesFromSyteline',
                'fetchSuppliers',
                'fetchSuppliersFromSyteline',
                'fetchUsers',
                'fetchPartNos',
                'fetchPartNoFromSyteline',
                'fetchAllLocationFromSyteline'
            ]),

            //NOTES
            //adds a new note
            async ajouterNote(newNote) {
                //saves new note and returns all notes of NC if the new one
                const notes = await this.ajouterNoteNonConformites({ nonConformite: this.nonConformite, note: newNote});

                //if the new note has been saved successfully
                if(!!notes) {
                    //updates NC
                    this.nonConformite.notes = notes;

                    //updates NC copy (ticket #39: the copy does not exist yet while creating a NC)
                    if (this.nonConformiteStore.nonConformite) {
                        this.nonConformiteStore.nonConformite.notes = notes;
                    }

                    this.newNote = "";
                }
            },

            noteTextChange(newNote) {
                this.newNote = newNote
            },

            //POP UP ALERT
            //creates pop up messages
            alert(type, message){
                this.$store.dispatch(APPLICATION_STORE.actions.AFFICHER_MESSAGE,
                    {
                        type: type,
                        text: message
                    }
                );
                if(this.loading){
                    this.loading = false;
                }

                if(this.loadingTransition){
                    this.loadingTransition = false;
                }
            },

            //ticket #41: errors.message comes from BaseRestController::error(), message from a Laravel validation error
            messageErreur(error) {
                return error.response?.data?.errors?.message || error.response?.data?.message || 'Une erreur est survenue';
            },

            async ouvrirSuppression() {
                this.suppression = { show: true, apercu: null, loadingApercu: true, loading: false };
                try {
                    this.suppression.apercu = await this.$store.dispatch('apercuSuppressionNonConformite', this.nonConformite.id);
                } catch (error) {
                    this.suppression.show = false;
                    this.alert('error', this.messageErreur(error));
                } finally {
                    this.suppression.loadingApercu = false;
                }
            },

            async supprimerNc(raison) {
                this.suppression.loading = true;
                try {
                    const syteline = await this.$store.dispatch('supprimerNonConformite', { nonConformiteId: this.nonConformite.id, raison });
                    const nonAnnules = (syteline.elements || []).filter(e => e.statut !== 'annule');
                    if (syteline.action === 'conserver' || nonAnnules.length > 0) {
                        //red, persistent snackbar (timeout 0): the user must read what is left to do in Syteline
                        this.alert('error', 'GNC supprimée, mais Syteline n\'a pas pu être entièrement annulé : '
                            + (syteline.raison || nonAnnules.map(e => e.libelle).join(', ')));
                    } else {
                        this.alert('success', 'GNC supprimée');
                    }
                    this.suppression.show = false;
                    this.nonConformiteSupprimee = true;
                    this.$router.push({ name: 'dashboard' });
                } catch (error) {
                    this.alert('error', this.messageErreur(error));
                } finally {
                    this.suppression.loading = false;
                }
            },

            //ChoiceBoxMessage
            openChoiceBoxMessage(content, btnParams) {
                this.$refs.choiceBoxMessage.displayAlert(content, btnParams);
                return new Promise(resolve => {
                    this.resolveChoiceBox = resolve;
                });
            },
            handleChoiceBoxMessageResponse(response) {
                if(response === 'avec'){
                    this.nonConformite.isNcNeedLabor = true;
                    this.isChoiceMade = true;
                }
                else if(response === 'sans'){
                    this.nonConformite.isNcNeedLabor = false;
                    this.isChoiceMade = true;
                }
                this.resolveChoiceBox(); //Resolve the Promise
            },

            //TRANSITIONS
            //executes transition
            async appliquerTransition(transition, fromType) {
                const data = {
                    nc: this.nonConformite,
                    transition: transition
                };

                const processTransition = async () => {
                    this.loadingTransition = true;

                    try {
                        const response = await this.$store.dispatch('applyTransition', data);
                        this.loadingTransition = false;
                        if(fromType !== "QUALITE_APPROUVED_SUP")
                        {
                            this.showMessage('success', 'Mise à jour effectuée avec succès');
                        }
                        this.nonConformite.history = response.history;
                        this.nonConformite.etat = response.history[0].to;
                    } catch (error) {
                        console.log(error);
                        this.showMessage('error', error);
                        this.loadingTransition = false;
                    }
                };

                if (transition === 'QUALITE_REJECT_DEMAND') {
                    await processTransition();
                    return;
                }

                try {
                    await this.submit("onCreateProject");
                    await processTransition();
                    this.copyNonConformite(utils.copyObject(this.nonConformite));

                    const response = await this.$store.dispatch(NON_CONFORMITES_STORE.actions.FETCH_LISTE_NOTIFICATIONS);

                    if (fromType === "QUALITE_APPROUVED_SUP" && this.nonConformite.projet.length === 0) {
                        await this.addNewProjectToSyteline('GNC');
                    }
                    else if(fromType === "ANNULER_TRAVAIL_APPROUVE"){
                        this.$refs.childMainComponent.onCancelTravailApprouveDisabled = true;
                    }
                    else if(fromType === "ANNULER_SOUMETTRE_TRAVAIL"){
                        this.$refs.childMainComponent.onCancelTravailaApprouveDisabled = true;
                    }

                    this.$refs.childMainComponent.getNcInfo();
                } catch (error) {
                    this.showMessage('error', "Erreur lors de l'envoi");
                    this.loadingTransition = false;
                }
            },

            showMessage(type, text) {
                this.message.type = type;
                this.message.text = text;
                this.$store.dispatch(APPLICATION_STORE.actions.AFFICHER_MESSAGE, this.message);
            },

            //PAGE UTILS
            //creates a copy of NC
            copyNonConformite(nonConformite){
                this.nonConformiteStore.nonConformite = utils.copyObject(nonConformite);
                this.nonConformiteStore.nonConformite.imageStructure = utils.copyObject(nonConformite.imagesFolder);
                this.nonConformiteStore.nonConformite.imagesSolution = utils.copyObject(nonConformite.imagesSolutionFolder);
            },

            //verifies if the page has unsaved modifications
            hasUnsavedChanges(){
                let nc_courante = utils.copyObject(this.nonConformite);

                nc_courante.imageStructure = utils.copyObject(this.imageStructure);
                nc_courante.imagesSolution = utils.copyObject(this.imagesSolution);

                nc_courante.imagesFolder = null;
                nc_courante.imagesSolutionFolder = null;

                if(this.nonConformiteStore.nonConformite){
                    this.nonConformiteStore.nonConformite.imagesFolder = null;
                }

                if(this.nonConformiteStore.nonConformite){
                    this.nonConformiteStore.nonConformite.imagesSolutionFolder = null;
                }

                return !isEqual(nc_courante, this.nonConformiteStore.nonConformite);
            },

            //CREATE/EDIT PAGE PARAMS
            //sets page params when creating a new NC
            async setParamsCreateNC(){
                this.title = "Création - Non conformité";
                this.abonnementNouvelUtilisateur = null;
                this.cycle = false;
                this.formValid = true;
                this.id = null;
                //sets images
                this.imageStructure = [];
                //sets solution images
                this.imagesSolution = [];
                this.nonConformite.id = null;
                this.nonConformite.titre = '';
                this.nonConformite.description = '';
                //sets tags
                this.nonConformite.tags = [];
                this.nonConformite.projet = '';
                this.nonConformite.noAssemblage = '';
                this.nonConformite.ncParentDepartementId = null;
                this.nonConformite.ncDepartementId = null;
                this.nonConformite.stageModel = '';
                this.nonConformite.stageId = null;
                this.nonConformite.stageUnit = '';
                this.nonConformite.stageUnitId = null;
                this.nonConformite.ncCategorieId = null;
                this.nonConformite.ncCauseId = null;
                this.nonConformite.causeFournisseurId = null;
                this.nonConformite.causeEmployeId = null;
                this.nonConformite.solutionRequise = false;
                this.nonConformite.solutionProposee = '';
                this.nonConformite.solutionAlternative = '';
                this.nonConformite.raisonRefus = '';
                this.nonConformite.history = [];
                this.nonConformite.dateEcheance = new Date().toISOString().substr(0, 10);
                this.nonConformite.estimeTemps = '';
                this.nonConformite.estimeHeures = null;
                this.nonConformite.estimeMinutes = null;
                this.nonConformite.gravite = 1;
                this.nonConformite.frequence = 1;
                this.nonConformite.assignationEmployeSigm = null;
                this.nonConformite.actionCorrectiveRequise = false;
                this.nonConformite.actionCorrectiveProposee = '';
                this.nonConformite.actionCorrectiveComplete = false;
                this.nonConformite.numeroNc = '';
                this.nonConformite.abonnes = [];
                this.nonConformite.createdAt = '';
                this.nonConformite.user = null;
                //sets files
                this.nonConformite.ncFichiers = [];
                //sets solution files
                this.nonConformite.ncFichiersSolution = [];
                this.nonConformite.estime = [];
                this.nonConformite.isReception = false;
                this.nonConformite.locationNc = 'rive_nord';

                //gets NC type depending on the query string passed in the route
                this.nonConformite.type = !!this.$route.query.mode ? this.$route.query.mode : 'qualite';
                this.nonConformite.showInQualite = this.nonConformite.type === 'qualite';
                this.nonConformite.showInMaintenance = this.nonConformite.type === 'maintenance';
                this.nonConformite.showInSav = this.nonConformite.type === 'sav';
                this.nonConformite.urgent = false;
                this.nonConformite.resolutionMembersList = null;
                this.nonConformite.axesAffaires = null;

                //gets correctives actions list by type
                //this function doesnt return anything, it sets the array of correctives actions of the store
                await this.fetchCorrectivesActionsByType(this.nonConformite.type);
            },

            //sets page params when editing an NC
            async setParamsEditNC(){
                this.title = "Modification - Non conformité";
                const response = await this.fetchNonConformiteById(this.$router.currentRoute.params.ncId);

                if(!!response) {
                    //feeds NC images
                    this.imageStructure = utils.copyObject(response.nonConformite.imagesFolder);
                    //feeds NC solution images
                    this.imagesSolution = utils.copyObject(response.nonConformite.imagesSolutionFolder);
                    //creates a copy of NC
                    this.nonConformite = response.nonConformite;

                    //on veut avoir les bonnes informations de projet
                    //this.setProjectInfo(); //Acienne logique SIGM

                    //sets Gallup infos (only if NC has a questionAnswerId)
                    this.gallupInfos = utils.copyObject(response.gallupInfos);

                    this.projectIncludesUnit = !!this.nonConformite.projet && !!this.nonConformite.stageUnitId;

                    //On set la copie de la nc pour les unsaved changes
                    this.copyNonConformite(utils.copyObject(response.nonConformite));

                    //gets correctives actions list by type
                    //this function doesnt return anything, it sets the array of correctives actions of the store
                    await this.fetchCorrectivesActionsByType(response.nonConformite.type);
                }
            },

            //PROJECT NUMBER
            //gets infos associated with project number (stage unit, stage model, etc...)
            setProjectInfo() {
                if (!!this.nonConformite.projet) {
                    this.projectMessages = [];
                    if (this.nonConformite.projet.includes('-')) {
                        //on cherche à valider un projet qui vient de SMART (locations)
                        this.$store.dispatch('validateSMARTProjectNumber', this.nonConformite.projet).then(valid => {
                            this.projectIncludesUnit = false;
                            if (valid === true) {
                                this.projectErrorMessages = [];
                                this.projectMessages = ["Il s'agit d'un projet de location, l'unité doit être spécifiée manuellement"];
                            } else {
                                this.projectErrorMessages = ["Numéro de projet inexistant dans SMART"];
                                this.projectMessages = [];
                            }
                        })
                    } else {
                        let data = {
                            projectNumber: this.nonConformite.projet
                        };
                        //***CHANGEMENT***
                            //this.$store.dispatch('fetchDataProjectNumber', data).then(response => {
                            this.$store.dispatch('fetchDataProjectNumberFromSyteline', data).then(response => {
                            let validProject = (response.data.projectNumber !== null);
                            this.projectErrorMessages = validProject ? [] : ['Numéro de projet inexistant dans SIGM'];
                            this.projectAvailableParts = response.data.availableParts;
                            this.projectAvailableUnits = response.data.stageUnits;
                            this.projectIncludesUnit = !!response.data.stageUnits && this.projectAvailableUnits.length === 1;
                            this.projectMessages = (validProject && (this.projectIncludesUnit || this.projectAvailableUnits.length > 0)) || !validProject ? [] : ["Le projet n'est pas lié à une unité dans SIGM"];

                            if (this.projectIncludesUnit) {
                                if(response.data.stageUnit){
                                    this.nonConformite.stageUnitId = response.data.stageUnit.id;
                                }
                                if(response.data.stageUnit && response.data.stageUnit.stage){
                                    this.nonConformite.stageId = response.data.stageUnit.stage.id;
                                }
                                if (this.nonConformite.stageId == null && response.data.stageUnit.genericModel != null) {
                                    let genericStage = this.entrepriseStore.stages.find(stage => stage.proposalModelName === response.data.stageUnit.genericModel);
                                    if (genericStage != null) {
                                        this.nonConformite.stageId = genericStage.id;
                                    }
                                }
                            }
                            else {
                                // this.nonConformite.stageUnitId = null;
                                // this.nonConformite.stageId = null;
                            }
                        });
                    }
                }
                else {
                    this.projectMessages = [];
                    this.projectErrorMessages = [];
                    this.projectAvailableParts = [];
                    this.projectIncludesUnit = false;
                    //this.nonConformite.stageUnitId = null;
                    //this.nonConformite.stageId = null;
                    //this.nonConformite.noAssemblage = '';
                }

                //parce que les changements affectent les autocompletes unit et stage mais ces derniers ne se reloadent pas toujours comme il faut
                this.$forceUpdate();
            },

            async setResolutionMembersList(value){
                this.nonConformite.resolutionMembersList = value;
                await this.$nextTick();
                // v-form est lazy; force une validation pour formValid à jour
                if (this.$refs.form) {
                    this.$refs.form.validate();
                }
            },

            changeNoAssemblage(value){
                if(this.nonConformite.projet.length > 0 && value !== undefined){
                    var modelName = '_' + (this.getNcStageModelName() === null ? '' : this.getNcStageModelName());
                    var unitName =  '_' + (this.getNcStageUnitName() === null ? '' : this.getNcStageUnitName());
                    let parts = this.nonConformite.projet.split('C');
                    let formatNumber = Number(parts[1]);
                    let projDesc = formatNumber + '_' + value.trim() + (unitName !== '_' ? unitName : (modelName !== '_' ? modelName : ''));

                    //Insertion des propriétés de dataProject
                    let dataProject = {
                        fromApp : 'GNC',
                        projNum : this.nonConformite.projet,
                        description : projDesc,
                    };

                    //Update Project Description
                    this.$store.dispatch('fetchUpdateProjectDescriptionToSyteline', dataProject).then(response => {
                        this.submit(null);
                    }).catch( error => {
                        this.alert('error', error.response.data.errors.message);
                    });
                }
                this.currentPartSelected = value;
            },

            //Recherche des pièces correspondante
            searchNoAssemblage(searchObject){
                this.fetchPartNoFromSyteline(searchObject);
            },

            async addNewProjectToSyteline(fromApp){
                //Le préfixe de projet GNC est suffixé selon la location (rive) de détection de la NC.
                //rive-sud => GNCV, rive-nord => GNCA. Syteline génère ensuite le numéro de séquence
                //via le placeholder '?' (ex.: GNCV0000001), chaque préfixe ayant sa propre séquence.
                if(fromApp === 'GNC'){
                    fromApp = this.nonConformite.locationNc === 'rive_sud' ? 'GNCV' : 'GNCA';
                }

                let completed = false;
                let partSelected = this.currentPartSelected.trim();

                if(partSelected.length > 0 || this.nonConformite.noAssemblage.length > 0){
                    //1-Récupérer les noms de models et d'unités
                    var newNumber = '0000001';
                    var modelName = '_' + (this.getNcStageModelName() === null ? '' : this.getNcStageModelName());
                    var unitName =  '_' + (this.getNcStageUnitName() === null ? '' : this.getNcStageUnitName());
                    var model = this.getNcStageModelName();

                    //2-rouver le dernier numéro de projet & Fabriquer le projDesc
                    await this.$store.dispatch('fetchLastProjectNumberFromSyteline', fromApp).then(response => {
                        this.lastGNCProjectsNumber = response.data.data;
                    });
                    if(this.lastGNCProjectsNumber !== null){
                        let lastCharFromKey = fromApp.substring(fromApp.length - 1);
                        let parts = this.lastGNCProjectsNumber.split(lastCharFromKey);
                        newNumber = Number(parts[1]) + 1;
                    }
                    (partSelected.length === 0 ? partSelected = this.nonConformite.noAssemblage.trim() : 0);
                    let projDesc = newNumber + '_' + partSelected + (unitName !== '_' ? unitName : (modelName !== '_' ? modelName : ''));

                    //3-Fabriquer le productCode
                    let productCode = utils.getProductCode(this.nonConformite, model);

                    //4-Insertion des propriétés de dataProject
                    let dataProject = {
                        fromApp: fromApp,
                        description: encodeURIComponent(projDesc),
                        productCode: productCode,
                        nonConformiteId: this.nonConformite.id
                    };

                    //5-Création d'un nouveau projet
                    await this.$store.dispatch('fetchAddNewProjectToSyteline', dataProject).then(response => {

                        /*2*/
                        let results = response.data.data;
                        this.newSytelineProjectNumber = results.projet[0].Value;
                        this.tryToCreateProjectFail = false;
                        completed = true;

                        let dataNonConformite = {
                            Id : this.nonConformite.id,
                            Projet : this.newSytelineProjectNumber
                        }

                        //6-Sauvegarde du nouveau numéro de projet dans la nonConformite
                        this.$store.dispatch('fetchAddNewProjectNumberToNonConformite', dataNonConformite).then(response => {
                            this.alert('success', "Le projet numéro # " + this.newSytelineProjectNumber +" a été créé avec succès!");
                        }).catch( error => {
                            this.tryToCreateProjectFail = true;
                            this.alert('error', error.response.data.errors.message);
                        });

                    }).catch( error => {
                        this.tryToCreateProjectFail = true;
                        this.alert('error', error.response.data.errors.message);
                    });
                }
                else{
                    this.tryToCreateProjectFail = true;
                    this.alert('error', 'Vous devez au minimum avoir choisi un numéro de pièce ou d\'assemblage');
                }

                return completed;
            },

            checkUp(){
                this.$store.dispatch('fetchCheckUpTypeFromSyteline').then(response => {

                }).catch( error => {
                    this.alert('error', error.response.data.errors.message);
                });
            },

            //FORM SUBMITION (VALIDATIONS)
            //submits form
            async submit(option) {
                try {
                    const isFormAllValidated = this.$refs.form.validate() && this.formValid && (this.imageStructure?.length > 0 || this.canSkipImage);
                    console.log(isFormAllValidated);

                    //onFloatingSave
                    if(isFormAllValidated && this.nonConformite.projet?.length === 0 && !this.nonConformite.isNcNeedLabor && option === 'onFloatingSave'){
                        await this.openChoiceBoxMessage(this.choiceBoxMessageContent, this.choiceBoxMessageBtnLabels);
                        if(!this.isChoiceMade){
                            return; //Stop function here
                        }
                    }

                    //ticket #39: on creation the NC has no id yet, the typed note is saved right after the NC
                    const noteToSaveAfterCreation = !this.nonConformite.id && !!this.newNote && this.newNote.trim() !== '' ? this.newNote : null;

                    if (this.newNote !== "" && !!this.nonConformite.id) {
                        await this.ajouterNote(this.newNote);
                    }
                        return new Promise((resolve, reject) => {
                            try {
                                if (isFormAllValidated) {
                                    this.loading = true;

                                    //initializing formData object for all files (files and solution files), images are sent one by one by the store (#40)
                                    let formDataFiles = new FormData();

                                    //NC data to save
                                    const data = {
                                        id: this.nonConformite.id,
                                        titre: this.nonConformite.titre,
                                        description: this.nonConformite.description,
                                        tags: this.nonConformite.tags,
                                        projet: this.nonConformite.projet,
                                        noAssemblage: this.nonConformite.noAssemblage,
                                        ncParentDepartementId: this.nonConformite.ncParentDepartementId,
                                        ncDepartementId: this.nonConformite.ncDepartementId,
                                        stageModel: this.getNcStageModelName(),
                                        stageId: this.nonConformite.stageId,
                                        stageUnit: this.getNcStageUnitName(),
                                        stageUnitId: this.nonConformite.stageUnitId,
                                        ncCategorieId: this.nonConformite.ncCategorieId,
                                        ncCauseId: this.nonConformite.ncCauseId,
                                        causeFournisseurId: this.nonConformite.causeFournisseurId,
                                        causeFournisseur: !!this.nonConformite.causeFournisseurId ? this.entrepriseStore.fournisseurs.find(f => {
                                            return f.VendNum === this.nonConformite.causeFournisseurId
                                        }).Name : null,
                                        causeEmployeId: this.nonConformite.causeEmployeId,
                                        causeEmploye: !!this.nonConformite.causeEmployeId ? this.entrepriseStore.employes.find(e => {
                                            return e.EmpNum === this.nonConformite.causeEmployeId
                                        }).Name : null,
                                        solutionRequise: this.nonConformite.solutionRequise,
                                        solutionProposee: this.nonConformite.solutionProposee,
                                        solutionAlternative: this.nonConformite.solutionAlternative,
                                        raisonRefus: this.nonConformite.raisonRefus,
                                        dateEcheance: this.nonConformite.dateEcheance,
                                        estimeTemps: this.nonConformite.estimeTemps,
                                        estimeHeures: this.nonConformite.estimeHeures,
                                        estimeMinutes: this.nonConformite.estimeMinutes,
                                        gravite: this.nonConformite.gravite,
                                        frequence: this.nonConformite.frequence,
                                        assignationEmployeSigm: this.nonConformite.assignationEmployeSigm,
                                        actionCorrectiveRequise: this.nonConformite.actionCorrectiveRequise,
                                        actionCorrectiveProposee: this.nonConformite.actionCorrectiveProposee,
                                        actionCorrectiveComplete: this.nonConformite.actionCorrectiveComplete,
                                        abonnes: this.nonConformite.abonnes,
                                        abonnesActionCorrective: this.nonConformite.abonnesActionCorrective,
                                        type: this.nonConformite.type,
                                        questionAnswerId: this.nonConformite.questionAnswerId,
                                        estime: this.nonConformite.estime,
                                        isReception: this.nonConformite.isReception,
                                        locationNc: this.nonConformite.locationNc,
                                        showInQualite: this.nonConformite.showInQualite,
                                        showInMaintenance: this.nonConformite.showInMaintenance,
                                        showInSav: this.nonConformite.showInSav,
                                        urgent: this.nonConformite.urgent,
                                        isNcNeedLabor: this.nonConformite.isNcNeedLabor,
                                        dateTask:this.nonConformite.dateTask,
                                        of:this.nonConformite.of,
                                        resolutionMembersList:this.nonConformite.resolutionMembersList,
                                    };

                                    //gets NC files to upload
                                    let fichiersToUpload = [];
                                    if (this.nonConformite.ncFichiers != null) {
                                        fichiersToUpload = this.nonConformite.ncFichiers.filter( fichier => fichier.toUpload === true);
                                        if (fichiersToUpload?.length > 0 ) {
                                            //adds files to upload to files form data
                                            fichiersToUpload.map( (fichier, index) => {
                                                formDataFiles.append(`fichiers[${index}]`, fichier.file);
                                            });
                                        }
                                    }


                                    //gets NC solution files to upload
                                    let fichiersSolutionToUpload = [];
                                    if (this.nonConformite.ncFichiersSolution != null) {
                                        fichiersSolutionToUpload = this.nonConformite.ncFichiersSolution.filter(fichier => fichier.toUpload === true);
                                        if (fichiersSolutionToUpload?.length > 0 ) {
                                            //adds solution files to upload to files form data
                                            fichiersSolutionToUpload.map( (fichier, index) => {
                                                formDataFiles.append(`fichiersSolution[${index}]`, fichier.file);
                                            });
                                        }
                                    }

                                    //SAVES NC DATA
                                    this.$store.dispatch(NON_CONFORMITES_STORE.actions.AJOUTER_NON_CONFORMITE, data).then(response => {
                                        this.nonConformite = response.nonConformite;

                                        //objects with all images to store (images and solution images)
                                        let dataImages = {
                                            nonConformite: response.nonConformite,
                                            images: this.imageStructure || [],
                                            imagesSolution: this.imagesSolution || [],
                                        };

                                        //SAVES NC IMAGES (images and solution images)
                                        this.$store.dispatch(NON_CONFORMITES_STORE.actions.AJOUTER_IMAGES_NON_CONFORMITE, dataImages).then(response => {
                                            //Feeder les carousel avec les photos
                                            this.imageStructure = response.nonConformite.imagesFolder;
                                            this.imagesSolution = response.nonConformite.imagesSolutionFolder;
                                            this.nonConformite = response.nonConformite;

                                            //objects with all files to store (files and solution files)
                                            let uploadFiles = {
                                                nbFichiers: fichiersToUpload?.length + fichiersSolutionToUpload?.length,
                                                nonConformite: response.nonConformite,
                                                fichiers: formDataFiles,
                                            };

                                            //SAVES NC FILES (files and solution files)
                                            this.$store.dispatch(NON_CONFORMITES_STORE.actions.AJOUTER_FICHIERS_NON_CONFORMITES, uploadFiles).then(async response => {
                                                //feeds NC files
                                                this.nonConformite.ncFichiers = utils.copyObject(response.nonConformite.ncFichiers);
                                                //feeds NC solution files
                                                this.nonConformite.ncFichiersSolution = utils.copyObject(response.nonConformite.ncFichiersSolution);

                                                //ticket #39: the NC now has an id, saves the note typed during creation
                                                if (noteToSaveAfterCreation) {
                                                    await this.ajouterNote(noteToSaveAfterCreation);
                                                }

                                                //if user was creating a new NC
                                                if (this.$router.currentRoute.name === 'create') {
                                                    //redirects user to edit page
                                                    this.$router.push(
                                                        {
                                                            name: 'edit',
                                                            params: {ncId: response.nonConformite.id}
                                                        }
                                                    );

                                                    //feeds création confirmation message
                                                    this.message.type = 'success';
                                                    this.message.text = 'Création de la non-conformité complété avec succès';
                                                //else, if user was editing an existing NC
                                                } else {
                                                    //feeds update confirmation message
                                                    this.message.type = 'success';
                                                    this.message.text = 'Mise à jour complété avec succès';
                                                }

                                                if(option === null){
                                                    //shows confirmation message to user
                                                    this.$store.dispatch(APPLICATION_STORE.actions.AFFICHER_MESSAGE, this.message);
                                                }

                                                this.loading = false;

                                                //creates a copy of NC
                                                this.copyNonConformite(utils.copyObject(this.nonConformite));
                                                resolve(true);
                                            }).catch(error => {
                                                //#170 / #40: the NC is saved but not its files, tell the user instead of failing silently
                                                this.showMessage('error', 'Erreur lors de l\'enregistrement des fichiers. Veuillez réessayer.');
                                                this.loading = false;
                                                reject(error);
                                            });

                                        }).catch(error => {
                                            //#170 / #40: the NC is saved but not its images, tell the user instead of failing silently
                                            this.showMessage('error', 'Certaines images n\'ont pas pu être enregistrées. Veuillez sauvegarder à nouveau.');
                                            this.loading = false;
                                            reject(error);
                                        });

                                    }).catch(error => {
                                        this.message.type = 'error';
                                        this.message.text = 'Erreur lors de la création de la non-conformité.';
                                        this.$store.dispatch(APPLICATION_STORE.actions.AFFICHER_MESSAGE, this.message);
                                        reject(error);
                                        this.loading = false;
                                    });
                                }
                                else{
                                    resolve(true);
                                }
                            } catch (e) {
                                this.alert('error', e.message);
                            }
                        });
                    } catch (e){
                        this.alert('error', e.message);
                }
            },

            //gets stage model name when submitting form
            getNcStageModelName(){
                return !!this.nonConformite.stageId ? this.$store.getters[ENTREPRISE_STORE.getters.GET_STAGE_MODEL_NAME](this.nonConformite.stageId) : null;
            },

            //gets stage unit name when submitting form
            getNcStageUnitName(){
                return !!this.nonConformite.stageUnitId ? this.$store.getters[ENTREPRISE_STORE.getters.GET_STAGE_UNIT_NAME](this.nonConformite.stageUnitId) : null;
            },

            //IMAGES
            //uploads images
            uploadImage(imageList) {
                this.imageStructure = this.imageStructure.concat(imageList);
            },

            //uploads solution images
            uploadImageSolution(imageList){
                this.imagesSolution = this.imagesSolution.concat(imageList);
            },

            //sets image to be opened in images dialog
            popUpImage({ img, origin }){
                this.image.src = img.src;
                this.image.visible = true;
                this.image.title = !!img.file ? img.file.name : img.title;
                this.image.origin = origin;
            },

            //deletes images
            removePhoto(image){
                this.$confirm("Voulez-vous vraiment supprimer cette image").then(res => {
                    if (res) {
                        if (image.origin === 'solution') {
                            //#14234: solution images have a relative src (/files/...), not https: test the server path instead
                            if (image.src.includes('/files/non-conformites/')) {
                                this.$store.dispatch('supprimerImageNonConformite', {nonConformite: this.nonConformite, image: image}).then(response => {
                                    if(!!response.nc) {
                                        this.imagesSolution = this.imagesSolution.filter(i => {
                                            return i.title !== image.title;
                                        });
                                    } else {
                                        console.log(response);
                                    }
                                });
                            } else {
                                this.imagesSolution = this.imagesSolution.filter(i => {
                                    return i.title !== image.title;
                                })
                            }
                        } else if (image.origin === 'structure') {
                            if (image.src.includes('/files/non-conformites/')) {
                                this.$store.dispatch('supprimerImageNonConformite', {nonConformite: this.nonConformite, image: image}).then(response => {
                                    if(!!response.nc) {
                                        this.imageStructure = this.imageStructure.filter(i => {
                                            return i.title !== image.title;
                                        });
                                    } else {
                                        console.log(response);
                                    }
                                });
                            } else {
                                this.imageStructure = this.imageStructure.filter(i => {
                                    return i.title !== image.title;
                                })
                            }
                        }
                        this.image.visible = false;
                    }
                });
            },

            //FILES
            //uploads files
            uploadFichiers(fileList){
                this.nonConformite.ncFichiers = this.nonConformite.ncFichiers.concat(fileList);
            },

            //uploads solution files
            uploadFichiersSolution(fileList){
                this.nonConformite.ncFichiersSolution = this.nonConformite.ncFichiersSolution.concat(fileList);
            },

            //deletes files
            async removeFile({ file, fileOrigin} ) {
                //if user really want to delete the file
                if(confirm('Êtes-vous sûre de vouloir supprimer ce fichier ?')) {
                    //if the solution file has not been uploaded yet
                    if(!!file.toUpload) {
                        //if file is a solution file
                        if(fileOrigin === 'solution') {
                            this.nonConformite.ncFichiersSolution = this.nonConformite.ncFichiersSolution.filter(f => f.name !== file.name);
                        }
                        //else
                        else if(fileOrigin === 'structure') {
                            this.nonConformite.ncFichiers = this.nonConformite.ncFichiers.filter(f => f.name !== file.name);
                        }
                    }
                    //else, if file is already uploaded
                    else {
                        //deletes file
                        const nc = await this.supprimerFichierNonConformite({
                            nonConformite: this.nonConformite,
                            file: file,
                            fileOrigin: fileOrigin,
                        });

                        //if file has been deleted successfully
                        if(!!nc) {
                            //if deleted file was a solution file
                            if(fileOrigin === 'solution') {
                                //puts all solution files to upload in the updated array of solution files
                                for(let solutionFile of this.nonConformite.ncFichiersSolution) {
                                    if(!!solutionFile.toUpload) {
                                        nc.ncFichiersSolution.push(solutionFile);
                                    }
                                }

                                this.nonConformite.ncFichiersSolution = nc.ncFichiersSolution;
                            }
                            //else
                            else if(fileOrigin === 'structure') {
                                //puts all files to upload in the updated array of files
                                for(let file of this.nonConformite.ncFichiers) {
                                    if(!!file.toUpload) {
                                        nc.ncFichiers.push(file);
                                    }
                                }

                                this.nonConformite.ncFichiers = nc.ncFichiers;

                            }
                        }
                    }
                }
            },

            //MEMBERS

            //sets corrections actions members list
            setCorrectiveActionMembers(members) {
                this.nonConformite.abonnesActionCorrective = members;
            },

            //adds selected user to NC members list
            setAbonnementNonconformite(userId){

                let data = {
                    nonConformiteId: this.nonConformite.id,
                    userId: userId
                };

                if (this.estAbonne) {
                    this.$store.dispatch('desabonnerUserNonConformite', data).then(response => {
                        this.nonConformite.abonnes = response.data.nonConformite.abonnes;
                        this.nonConformite.abonnesActionCorrective = response.data.nonConformite.abonnesActionCorrective;
                        //this.nonConformiteStore.nonConformite.abonnes = utils.copyObject(response.data.nonConformite.abonnes);
                    });
                }
                else {
                    this.$store.dispatch('abonnerUserNonConformite', data).then(response => {
                        this.nonConformite.abonnes = response.data.nonConformite.abonnes;
                        this.nonConformite.abonnesActionCorrective = response.data.nonConformite.abonnesActionCorrective;
                        //this.nonConformiteStore.nonConformite.abonnes = utils.copyObject(response.data.nonConformite.abonnes);
                    });
                }
            },

            updateGncMessage(response){
                this.alert(response.type, response.message);
            },

            changeAxeAffaire(value){
                let data = {
                    id: this.nonConformite.id,
                    axe: value
                };

                this.$store.dispatch('updateAxeAffaireNc', data).then(response => {
                    this.nonConformite = response;
                });
            },

            formatDateTime(dateTimeCreated) {
                let splitDateTime = dateTimeCreated.split('T');
                let date = splitDateTime[0];
                let time = splitDateTime[1].split('-')[0];
                return date + ' à ' + time;
            }
        },

        beforeRouteLeave (to, from, next) {
            //ticket #41: a deleted NC has nothing left to save
            if( !(to.name === 'edit' && from.name === 'create') && !this.nonConformiteSupprimee){
                if (this.hasUnsavedChanges() ){
                    let width = 0;
                    switch (this.$vuetify.breakpoint.name) {
                        case 'xs':
                            width = 290;
                            break;
                        case 'sm':
                            width = 290;
                            break;
                        case 'md':
                            width = this.$vuetify.breakpoint.width * 0.2;
                            break;
                        case 'lg':
                            width = this.$vuetify.breakpoint.width * 0.3;
                            break
                        case 'xl':
                            width = this.$vuetify.breakpoint.width * 0.4;
                            break;
                    }
                    this.$confirm('Êtes-vous sûr de vouloir quitter, vous avez des changements qui n\'ont pas été sauvegardés ?',
                        {
                            title: 'Quitter ?',
                            width: width,
                            persistent: true,
                            buttonTrueText: 'Quitter',
                            buttonFalseText: 'Rester',
                            icon: 'warning'
                        }).then(res => {
                            if(res){
                                next();
                            } else {
                                next(false);
                            }
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    }
</script>

<style scoped>
    .upload-btn i {
        margin: 0;
    }
    .upload-btn {
        padding-left: 0;
    }
    #btn_save{
        background-color: green !important;
    }

    #btn_save[disabled="disabled"]{
        background-color: rgba(25, 155, 9, 0.95) !important;
    }
</style>
